import getEnv from './utils/env';

const poolData = {
  UserPoolId: getEnv('VUE_APP_COGNITO_USER_POOL_ID'),
  ClientId: getEnv('VUE_APP_COGNITO_CLIENT_ID'),
};

export default {
  poolData,
};
